module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_intro-1a9e5a56110b578ba7c45ec5d90084ef.png";